// This file is auto-generated during the build process
export const BUILD_VERSION = "20261027-4";
export const BUILD_DATE = "2026-10-27T16:51:32.148Z";
